import React, { useState } from "react"
import styles from './chatBar.module.css'
import {AiOutlineLeft,AiOutlineRight} from "react-icons/ai"
import {RiWechatLine} from 'react-icons/ri'
const ChatBar =()=>{

    const [hide,setHide]=useState(true);


    return(<div style={{right:hide?"-18%":"0px"}} className={styles.container}>
        <div className={styles.header}><RiWechatLine style={{color:"#50138c",fontSize:"20px"}}/>
        <div className={styles.heading}>Messages</div>
        </div>
        <div className={styles.search}>
          <input placeholder="Search"/>

        </div>
   <div className={styles.chatcon}>
      
        <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>laira01</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
         <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>shaunjp</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
         <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcsjMZRq5tDcW-zaTDcZL01NOCrDYLglPqfQ&usqp=CAU"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>tomcro</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
        
         <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="https://www.wllawsd.com/wp-content/uploads/2018/06/daniel-1.jpg"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>max_doe</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
         <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="http://eyeleveljlt.com/images/team/team-2.jpg"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>brad09</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
         <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>laira01</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
         <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>shaunjp</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
         <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcsjMZRq5tDcW-zaTDcZL01NOCrDYLglPqfQ&usqp=CAU"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>tomcro</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
       
         <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="https://www.wllawsd.com/wp-content/uploads/2018/06/daniel-1.jpg"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>max_doe</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
         <div className={styles.chatitem}>
       <img className={styles.userimg} alt="profile"  src="http://eyeleveljlt.com/images/team/team-2.jpg"/>
       <div className={styles.txtcon}>
        <div style={{fontWeight:"400"}}>brad09</div>
        <div style={{fontWeight:"200",fontSize:"small",marginTop:"-5px"}}>New meeaage lore..sasddsdddd....</div>
        </div>
         </div>
  
       
       
         </div>



         {hide?<AiOutlineLeft onClick={()=>setHide(!hide)} className={styles.msgicon}/>
        :<AiOutlineRight onClick={()=>setHide(!hide)} className={styles.msgicon}/>}

    </div>)

}

export default ChatBar

